import React from 'react';
import { Applications } from 'src/components/ProgramDetails/Applications';
import { Concentrations } from 'src/components/ProgramDetails/Concentrations';
import { Institution } from 'src/components/ProgramDetails/Institution';
import { Overview } from 'src/components/ProgramDetails/Overview';
import { Requirements } from 'src/components/ProgramDetails/Requirements';
import { WhatYoullLearn } from 'src/components/ProgramDetails/WhatYoullLearn';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import {
	GetRolesForProgramsQuery,
	GetProgramOutQuery,
} from 'src/graphqlTypes/roleProgramGraphServiceTypes';
import { usePricebook } from '@src/components/Providers/PricebookProvider';
import { CareerPathways } from '../CareerPathways/CareerPathways';
import { Tuition } from '../Tuition';

interface Props {
	loading: boolean;
	program: GetMemberProgramQuery['memberProgram'];
	rolesForPrograms: GetRolesForProgramsQuery['rolesForPrograms'];
	destinationRoles?: GetProgramOutQuery['getProgramOut'];
}

export const AboutProgram: React.FC<Props> = ({
	loading,
	program,
	rolesForPrograms,
	destinationRoles,
}) => {
	const { showCost } = usePricebook();

	if (!program) {
		return null;
	}

	return (
		<div className='content-container'>
			<Overview loading={loading} program={program} />
			<Concentrations loading={loading} program={program} />
			<WhatYoullLearn loading={loading} program={program} />
			{(rolesForPrograms && rolesForPrograms.length > 0) ||
			(destinationRoles && destinationRoles.length > 0) ? (
				<CareerPathways
					destinationRoles={destinationRoles}
					loading={loading}
					program={program}
					rolesForPrograms={rolesForPrograms}
				/>
			) : null}
			<Institution loading={loading} program={program} />
			{showCost ? <Tuition loading={loading} program={program} /> : null}
			<Requirements loading={loading} program={program} />
			<Applications loading={loading} program={program} />
		</div>
	);
};
